import { createSelector, defaultMemoize } from 'reselect';
import { userSchema } from '../normalizr/schemas/user';
import { getDataEntityById, getAllDataEntitiesForSchema } from '../entities';
import objValues from 'lodash/values';
export const getUserById = defaultMemoize((state, id)=>getDataEntityById(state, userSchema, id));
export const getUsersByUsernames = createSelector([
    (state)=>getAllDataEntitiesForSchema(state, userSchema),
    (state, usernames = [])=>usernames.map((username)=>username.toLowerCase())
], (usersKeyedByIds, usernames)=>objValues(usersKeyedByIds).filter((user)=>usernames.includes(user.username.toLowerCase())));
export const createGetUsersByIds = ()=>createSelector([
        (state)=>getAllDataEntitiesForSchema(state, userSchema),
        (state, ids)=>ids
    ], (usersKeyedByIds, ids)=>ids.map((id)=>usersKeyedByIds[id]));
export const getUsersByIds = createGetUsersByIds();
